import { Form } from 'react-bootstrap'
import Select from 'react-select'
import { IFilterSelectSingle } from '../../types'
import uniqid from 'uniqid'
import { useAtomValue } from 'jotai'
import * as state from '../../states'
import { ISelectOption } from '../../types/ui'
import { reactSelectStyles } from './filterHelpers'
import { ALL_LANG_KEY } from '../../types/lang'
import { useTranslation } from 'react-i18next'

export const FilterSelectSingle = (props: IFilterSelectSingle<string>) => {
	const {
		attr,
		value,
		setValue,
		options,
		label,
		placeholder,
		styles = {},
		isSearchable = false,
		isClearable = false,
		isDisabled = false
	} = props
	const { t } = useTranslation()
	const key = uniqid()
	const isThemeDark = useAtomValue(state.themeIsDarkAtom)
	const foundValue = options.find(item => item.value === value) ?? null

	return (
		<div className={'filter-input-cont'} style={styles}>
			{label ? <Form.Label className="text-dark" htmlFor={`select-single-${key}`}>{label}</Form.Label> : null}

			<Select
				inputId={`select-single-${key}`}
				className="react-select-container"
				classNamePrefix="react-select"
				{...attr}
				options={options}
				value={foundValue}
				placeholder={placeholder ?? `${t(ALL_LANG_KEY.general.react_select_placeholder)}`}
				noOptionsMessage={() => `${t(ALL_LANG_KEY.general.react_select_no_options)}`}
				isSearchable={isSearchable}
				isClearable={isClearable}
				isDisabled={isDisabled}
				isMulti={false}
				styles={reactSelectStyles<ISelectOption<string>, false>(isThemeDark)}
				onChange={(selectedItem) => {
					setValue(selectedItem?.value ?? null)
				}}
			/>
		</div>
	)
}